/** Utilidades de fechas calendario (formato ISO `AAAA-MM-DD`, sin zona). */

export function sumarDias(fechaIso: string, dias: number): string {
  const [a, m, d] = fechaIso.split('-').map(Number);
  const fecha = new Date(Date.UTC(a, m - 1, d + dias));
  return fecha.toISOString().slice(0, 10);
}

export function compararFechas(a: string, b: string): number {
  return a < b ? -1 : a > b ? 1 : 0;
}

export function formatearFechaCorta(fechaIso: string): string {
  const [a, m, d] = fechaIso.split('-');
  return `${d}/${m}/${a}`;
}

export function fechaLocalIso(fecha = new Date()): string {
  const off = fecha.getTimezoneOffset();
  return new Date(fecha.getTime() - off * 60_000).toISOString().slice(0, 10);
}
